import dayjs from 'dayjs';
import {
  ACCESS_TIME_STATUS,
  type BookingSummary,
  type ShortReservation,
} from '@chekin/core';

export function isWithinAccessWindow(
  checkInDate: string | undefined,
  startTime: string | undefined,
  checkOutDate: string | undefined,
  endTime: string | undefined,
  now = new Date(),
): boolean {
  if (!checkInDate || !startTime || !checkOutDate || !endTime) return true;

  const nowDt = dayjs(now);
  const startDt = dayjs(`${checkInDate.slice(0, 10)}T${startTime}`);
  const endDt = dayjs(`${checkOutDate.slice(0, 10)}T${endTime}`);

  return !nowDt.isBefore(startDt) && !nowDt.isAfter(endDt);
}

export function getAccessWindow(
  summary: BookingSummary | undefined,
  reservation: ShortReservation | undefined,
): {
  startTime: string | undefined;
  endTime: string | undefined;
  checkInDate: string | undefined;
  checkOutDate: string | undefined;
} {
  if (summary?.access_time_status === ACCESS_TIME_STATUS.custom) {
    return {
      startTime: summary.access_start_time,
      endTime: summary.access_end_time,
      checkInDate: summary.check_in_date,
      checkOutDate: summary.check_out_date,
    };
  }
  return {
    startTime: reservation?.access_start_time,
    endTime: reservation?.access_end_time,
    checkInDate: reservation?.check_in_date,
    checkOutDate: reservation?.check_out_date,
  };
}
